import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import IconHeart2 from 'components/icons/iconHeart2';

const PDPFavoriteButtonUI = ({
  isFavorited,
  onFavClick,
  size = 'md',
  className,
}) => (
  <button
    type="button"
    onClick={onFavClick}
    className={cx(
      `h-12 w-12 flex justify-center items-center rounded-[50%] flex-shrink-0 cursor-pointer ml-[5px] border-0 bg-white hover:bg-gray-light8 ${className}`,
      {
        '[&_svg_path]:fill-[#d86262] [&_svg_path]:stroke-[#d86262]': isFavorited,
        'h-8 w-8': size === 'xs',
        'h-10 w-10': size === 'sm',
      }
    )}
    data-xc="favorite-button"
  >
    <span className="items-center flex justify-center">
      <IconHeart2
        className={cx({
          'animate-heartbeat': isFavorited,
        })}
        height={size === 'md' ? 22 : 17}
        width={size === 'md' ? 24 : 19}
      />
    </span>
  </button>
);

PDPFavoriteButtonUI.propTypes = {
  isFavorited: PropTypes.bool,
  onFavClick: PropTypes.func,
  size: PropTypes.oneOf(['xs', 'sm', 'md']),
  className: PropTypes.string,
};

export default PDPFavoriteButtonUI;
